import { Component, inject } from '@angular/core';
import { CompanyTableComponent } from "../../components/tables/manage-account/company-table/company-table.component";
import { SidebarComponent } from '../../components/sidebars/sidebar/sidebar.component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-company',
  imports: [CompanyTableComponent],
  templateUrl: './company.component.html',
  styleUrl: './company.component.scss'
})
export class CompanyComponent {
  private router = inject(Router);

  navigateToCreateAccount() {
    this.router.navigate(['/social-ai-admin']);
  }

}
